"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSupported = exports.isFirefox = exports.hasConsole = void 0;
function browser() {
    var browserName = 'unknown';
    if (navigator) {
        var userAgent = navigator.userAgent;
        if (userAgent) {
            if (userAgent.indexOf('Firefox') > -1) {
                browserName = 'Mozilla Firefox';
            }
            else if (userAgent.indexOf('SamsungBrowser') > -1) {
                browserName = 'Samsung Internet';
            }
            else if (userAgent.indexOf('Opera') > -1 ||
                userAgent.indexOf('OPR') > -1) {
                browserName = 'Opera';
            }
            else if (userAgent.indexOf('Trident') > -1) {
                browserName = 'Microsoft Internet Explorer';
            }
            else if (userAgent.indexOf('Edge') > -1) {
                browserName = 'Microsoft Edge';
            }
            else if (userAgent.indexOf('Chrome') > -1) {
                browserName = 'Google Chrome or Chromium';
            }
            else if (userAgent.indexOf('Safari') > -1) {
                browserName = 'Apple Safari';
            }
        }
    }
    return browserName;
}
function isTabletOrPhone() {
    if (navigator) {
        var userAgent = navigator.userAgent;
        if (userAgent) {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
        }
    }
    return false;
}
function hasConsole() {
    return isTabletOrPhone() === false;
}
exports.hasConsole = hasConsole;
function isFirefox() {
    return browser() === 'Mozilla Firefox';
}
exports.isFirefox = isFirefox;
function isSupported() {
    var browserName = browser();
    switch (browserName) {
        case 'Mozilla Firefox':
        case 'Google Chrome or Chromium':
        case 'Apple Safari':
            return true;
        default:
            return false;
    }
}
exports.isSupported = isSupported;
